import { Controller } from "@hotwired/stimulus"

// AB-053 — On <img> error, swap the broken-thumbnail to a placeholder asset.
// Mounted on <img> elements that may receive a video-mp4 URL by mistake or a
// 404'd thumbnail. Avoids leaving the user staring at a broken-image icon.
export default class extends Controller {
  static values = { placeholder: String }

  connect() {
    console.log(`[thumbnail-fallback] connect: placeholder =`, this.placeholderValue || "(empty)")
  }

  fallback(event) {
    const img = event.target
    if (!img || !img.tagName || img.tagName !== "IMG") return
    const placeholder = this.placeholderValue
    // Guard against an infinite loop if the placeholder itself fails to load.
    if (!placeholder || img.src === placeholder || img.dataset.thumbnailFallbackApplied === "true") {
      console.error(`[thumbnail-fallback] placeholder unavailable or already applied — leaving img as-is`)
      return
    }
    console.log(`[thumbnail-fallback] swapping broken thumbnail`, img.src, "→", placeholder)
    img.src = placeholder
    img.dataset.thumbnailFallbackApplied = "true"
  }

  disconnect() {
    console.log(`[thumbnail-fallback] disconnect`)
  }
}
